/* tslint:disable */
/* eslint-disable */
/**
 * classes-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const OverrideReasons = {
    SpecialPriceChanged: 'Special price changed',
    SpecialPriceAdjustment: 'Special price adjustment',
    SubsidizedForCoreSession: 'Subsidized for Core session',
    HousingSubsidized: 'Housing subsidized',
    SubsidizedForStudentNeed: 'Subsidized for student need',
    SubsidizedForInventorySurplus: 'Subsidized for inventory surplus',
    Accommodations: 'Accommodations',
    IncreasedForRoomUpgradeReconfiguration: 'Increased for room upgrade/reconfiguration',
    PriceAdjustment: 'Price adjustment',
    SessionLengthChanged: 'Session length changed',
    ApiCanceledExcursion: 'API canceled excursion',
    IndependentHousing: 'Independent Housing'
} as const;

export type OverrideReasons = typeof OverrideReasons[keyof typeof OverrideReasons];



